"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSvgNameByEmoji = exports.symbolToHex = void 0;
var supportedFlags_1 = require("./generated/supportedFlags");
var symbolToHex = function (str) {
    var _a;
    var parts = [];
    for (var i = 0; i < str.length; i = i + 2) {
        parts.push((_a = str.codePointAt(i)) === null || _a === void 0 ? void 0 : _a.toString(16));
    }
    return parts.join('-');
};
exports.symbolToHex = symbolToHex;
var getSvgNameByEmoji = function (emoji) {
    if (supportedFlags_1.supportedFlags.indexOf(emoji) < 0) {
        throw new Error('Flag is not supported');
    }
    return exports.symbolToHex(emoji);
};
exports.getSvgNameByEmoji = getSvgNameByEmoji;
//# sourceMappingURL=flags.js.map